import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import React from 'react';
import { PdfViewerTrigger } from '../../../../../context/pdfViewerDialog';
import Icons from '../../../../../components/Common/Icons/Icons';

export function GuidanceViewCheckImageButton({
  src = '/guidance/checkImages/checkImage.html',
  children,
}: { src?: string } & React.PropsWithChildren) {
  return (
    <PdfViewerTrigger modalTitle="Check view" src={src}>
      <a
        href="#"
        aria-label="download-pdf"
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}
        className="border-[1px] h-[36px] border-primary bg-white text-primary px-2 md:px-[15px] py-[5px]
          flex gap-[5px] items-center hover:bg-primary hover:text-white rounded-lg whitespace-nowrap"
      >
        <Icons.UserCheck />
        <div className="font-bold">{children}</div>
      </a>
    </PdfViewerTrigger>
  );
}

export interface ICheckImagesData {
  id: string;
  date: string;
  number: number;
  amount: number;
}

export const checkImagesCol: ColumnDef<ICheckImagesData>[] = [
  {
    header: 'Date',
    accessorKey: 'date',
  },
  {
    header: 'Check Number',
    accessorKey: 'number',
    cell: ({ getValue }) => <GuidanceViewCheckImageButton>{getValue<string>()}</GuidanceViewCheckImageButton>,
  },
  {
    header: 'Amount',
    accessorKey: 'amount',
    cell: ({ getValue }) => `$${getValue<number>().toFixed(2)}`,
  },
];

function formatCheckDate(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  };

  return date.toLocaleDateString('en-US', options);
}

function generateCheckImagesData(): ICheckImagesData[] {
  const now = dayjs();
  const currentMonth = now.month();
  const baseCheckNumber = 91870;
  const amounts = [100, 300, 100, 400, 600];

  return Array.from({ length: 5 }, (_, i) => {
    const date = now.subtract(i, 'month');
    const monthOfDate = date.month();
    let day: number;

    if (monthOfDate === currentMonth) {
      day = 1;
    } else if (i % 2 === 0) {
      day = 5;
    } else {
      day = 11;
    }

    return {
      id: String(i + 1),
      date: date.date(day).format('MMMM D, YYYY'),
      number: baseCheckNumber + i,
      amount: amounts[i],
    };
  });
}

export const checkImagesData: ICheckImagesData[] = generateCheckImagesData();
